// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Case_360_view {
  font-size: 12px !important;
}

.otherInformation {
  font-family: montserrat;
}

.labotherInformation {
  font-family: Nunito, sans-serif !important;
}

.eventselecttypeControl {
  width: 96%;
  border: none;
  padding-block: 2px;
  height: 28px;
  margin-left: 2%;
  padding-right: 23px !important;
}

.blod_text {
  color: #007887;
}

.date_control_style {
  width: 30%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.close_icon {
  position: absolute;
  top: 27%;
  font-size: 16px;
  cursor: pointer;
  color: grey;
  font-weight: 600;
  right: 0;
}

.help-main-title {
  font-size: 17px;
  text-align: center;
}

.case_details {
  flex: auto;
  text-align: center;
  position: relative;
}

.caseHeaderBorder {
  height: 14px;
  width: 2px;
  background-color: #17a0b4 !important;
  position: absolute;
  top: 14%;
  right: 0%;
}

.case_info {
  background: #E2E2E2 0% 0% no-repeat padding-box;
  padding-inline: 8px;
}

::ng-deep.case_tabs .mat-tab-header {
  height: 33px;
}

.active_img {
  display: none;
}

.inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.active_img_inbound {
  display: none;
}

.inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

.event_card_info {
  border-left: 3px solid #007887;
  margin-left: 2px;
}
.event_card_info .header {
  height: 50px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
}

.Event_lables {
  height: 60px;
  background: #E5F1F3;
  padding-inline: 13px;
}

.eventtype_lables {
  background-color: white;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  box-shadow: 1px 1px 4px 0px grey;
}

.eventtype_lables_active {
  background-color: #007887;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  color: white;
  box-shadow: 1px 1px 4px 0px grey;
}

.messageInfo {
  border-left: 4px solid green;
  box-shadow: 1px 1px 6px 0px grey;
  border-radius: 5px;
  padding-inline: 6px;
  padding-block: 3px;
}

.cardActive {
  background-color: #CCE4E7;
}

.listview {
  padding-inline: 19px;
  max-height: 53vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.view_file_icon {
  width: 19px !important;
  float: left;
  position: relative;
  top: -3px;
  left: 6px;
}

.barline {
  height: 1px;
  background-color: black;
  margin-inline: 13px;
}

.lables_status {
  border-radius: 4px;
  padding-block: 3px;
  font-size: 10px;
  font-weight: 600;
}

::ng-deep.viewstages .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstages {
  top: 4% !important;
}

.inputContainer {
  height: 81vh;
  background-color: #F3F3F3;
  border: 1px solid #707070;
}
.inputContainer .header {
  background-color: #D1D1D1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.outputContainer {
  height: 81vh;
  background-color: #F3F3F3;
  border: 1px solid #707070;
}
.outputContainer .header {
  background-color: #D1D1D1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.icons_list_style {
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.icons_list_style_active {
  border-bottom: 3px solid #00BCD4;
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.case_info_container {
  border: 1.5px solid #17a0b4;
  padding: 5px;
  position: relative;
  margin-block: 16px;
}

.card_label_title {
  background-color: #fbfbfb;
  position: absolute;
  padding-inline: 5px;
  font-size: 10px;
  top: -9px;
  color: #001C3B;
  font-weight: 600;
}

.lables_style {
  font-size: 10px !important;
  color: #001C3B;
  font-weight: 600;
  padding: 3px;
}

.value_style {
  font-weight: 600;
  font-size: 10px;
  color: #5682A6 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.supplemental_info {
  height: 13vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.inter_case_notes {
  height: 19vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.archival_material {
  height: 8vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.clinial_information {
  height: 10vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.special_instructions {
  height: 10vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.processing_notes {
  height: 14vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.case_comments {
  height: 14vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.supplemental_information {
  height: 10vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.case_rejections {
  height: 10vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.Revison_reason {
  height: 10vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.sec_date {
  font-size: 10px;
}

.pt_date {
  font-size: 9px;
  margin-left: 3px;
}

.more_info {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.orderedDate {
  color: #827EC4 !important;
}

.collectionDate {
  color: #80A8D0 !important;
}

.receivedDate {
  color: #278C7D !important;
}

.signedoutDate {
  color: #D17800 !important;
}

.reportDate {
  color: #C02755 !important;
}

.sendinDate {
  color: #443EA7 !important;
}

.sendoutDate {
  color: #3575B5 !important;
}

.insurance_more_info {
  height: 62.5vh;
}

.text_elip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.flag_class {
  background-color: #E8E8E5;
  min-width: auto;
  border-radius: 3px;
  color: #001C3B;
  font-size: 11px;
  min-width: 164px !important;
  padding-inline: 6px;
  padding-block: 2px;
  margin: 3px;
  max-width: 320px;
}

.no_data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #001C3B;
}

.test_results,
.observation_set_results,
.standalone_results {
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: 11px;
}

.truncate-text {
  max-width: 24ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.special_result_content {
  font-size: 10px;
  color: #5682A6;
  font-weight: 600;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 5px;
  line-height: 1.5;
}

.sub_groups_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sub_group_box {
  border: 1px solid #17a0b4;
  border-radius: 3px;
  padding: 5px;
  flex: 1 1 calc(50% - 8px);
  min-width: 120px;
  background-color: #f9f9f9;
}

.sub_group_heading {
  font-size: 9px;
  font-weight: 700;
  color: #17a0b4;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 4px;
  padding-bottom: 2px;
}

.material_control {
  width: 100%;
  height: 17px;
  border: 1px solid #0d5964;
  border-radius: 3px;
}

::ng-deep.myCustomModalViewfile .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

.timezone-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 80px;
  height: 40px;
  z-index: 1000;
}
.timezone-notice .timezone-notice-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  height: 100%;
  padding-left: 15px;
}
.timezone-notice .timezone-notice-content i {
  margin-right: 8px;
  color: #17a2b8;
  font-size: 14px;
}
.timezone-notice .timezone-notice-content span {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/otherinfo/otherinfo.component.scss"],"names":[],"mappings":"AAGA;EACE,0BAAA;AADF;;AAKA;EACE,uBAAA;AAFF;;AAIA;EACE,0CAAA;AADF;;AAGA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AACA;EACE,UAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AAGF;;AADA;EACE,eAAA;EACA,kBAAA;AAIF;;AAFA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;AAKF;;AADA;EACE,YAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAIF;;AAFA;EACE,+CAAA;EACA,mBAAA;AAKF;;AADE;EACE,YAAA;AAIJ;;AAAA;EACE,aAAA;AAGF;;AADQ;EACN,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAIF;;AAFA;EACE,aAAA;AAKF;;AAHQ;EACN,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAMF;;AAFA;EAEE,8BAAA;EACA,gBAAA;AAIF;AAHE;EACE,YAAA;EAAa,+CAAA;AAMjB;;AAHA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AAMF;;AAJA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAOF;;AAJA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AAOF;;AAIA;EACE,4BAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACA,yBAAA;AADA;;AAIA;EACE,oBAAA;EAAqB,gBAAA;EAAiB,kBAAA;EAAmB,gBAAA;AAE3D;;AAEA;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AACJ;;AAGA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AADF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAAF;AACE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AACJ;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AACF;AAAE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAEJ;;AAEA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AACA;EACE,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AAEA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAGA;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAAF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AACN;;AACA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAER;;AAAA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAGR;;AADA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAIR;;AAFA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAKR;;AAHA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAMR;;AAJA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAOR;;AALA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACI,eAAA;AAQR;;AANA;EACI,YAAA;EACC,kBAAA;EACH,gBAAA;EACI,eAAA;AASN;;AAPA;EACI,YAAA;EACC,kBAAA;EACH,gBAAA;EACI,eAAA;AAUN;;AARA;EAEI,eAAA;AAUJ;;AANA;EAEI,cAAA;EACA,gBAAA;AAQJ;;AAJA;EACE,WAAA;EACE,0BAAA;EACA,eAAA;AAOJ;;AAHA;EACE,yBAAA;AAMF;;AAJA;EACE,yBAAA;AAOF;;AALA;EACE,yBAAA;AAQF;;AANA;EACE,yBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AARA;EACE,yBAAA;AAWF;;AATA;EACE,yBAAA;AAYF;;AARA;EACE,cAAA;AAWF;;AARA;EACkB,uBAAA;EACA,mBAAA;EACA,kBAAA;AAWlB;;AAPA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAUF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AASF;;AALA;;;EAGE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAQF;;AAJA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAOF;;AAFA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AAKF;;AAFA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAKF;;AAFA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAKF;;AAFA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAMF;;AAHA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAO3B;;AAHA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAMF;AAJE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAMJ;AAJI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAMN;AAHI;EACE,gBAAA;AAKN","sourcesContent":["@import '../../../variables.scss'  ;\r\n@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.Case_360_view{\r\n  font-size: 12px !important;\r\n}\r\n\r\n\r\n.otherInformation{\r\n  font-family: montserrat;\r\n}\r\n.labotherInformation{\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n.eventselecttypeControl{\r\n  width: 96%;\r\n  border: none;\r\n  padding-block: 2px;\r\n  height: 28px;\r\n  margin-left: 2%;\r\n  padding-right: 23px !important;\r\n}\r\n.blod_text{\r\n  color: #007887;\r\n}\r\n.date_control_style {\r\n  width: 30%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n}\r\n.close_icon{\r\n  position: absolute;\r\n  top: 27%;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: grey;\r\n  font-weight: 600;\r\n  right: 0;\r\n}\r\n.help-main-title{\r\n  font-size:17px;\r\n  text-align: center;\r\n}\r\n.case_details{\r\n  flex: auto;\r\n  text-align: center;\r\n  position: relative;\r\n//   width: 14.28%;\r\n// float: left;\r\n}\r\n.caseHeaderBorder{\r\n  height: 14px;\r\n  width: 2px;\r\n  background-color: #17a0b4 !important;\r\n  position: absolute;\r\n  top: 14%;\r\n  right: 0%;\r\n}\r\n.case_info{\r\n  background: #E2E2E2 0% 0% no-repeat padding-box;\r\n  padding-inline: 8px;\r\n  // border-radius: 5px;\r\n}\r\n::ng-deep.case_tabs{\r\n  .mat-tab-header{\r\n    height: 33px;\r\n  }\r\n}\r\n\r\n.active_img{\r\n  display: none;\r\n        }\r\n        .inactive_img{\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n        }\r\n.active_img_inbound{\r\n  display: none;\r\n        }\r\n        .inactive_img_inbound{\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n        }\r\n\r\n\r\n.event_card_info{\r\n  // height: 75vh;\r\n  border-left: 3px solid #007887;\r\n  margin-left: 2px;\r\n  .header{\r\n    height: 50px;background: #F2F2F2 0% 0% no-repeat padding-box;\r\n  }\r\n}\r\n.Event_lables{\r\n  height: 60px;\r\n  background: #E5F1F3;\r\n  padding-inline: 13px;\r\n}\r\n.eventtype_lables{\r\n  background-color: white;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n\r\n.eventtype_lables_active{\r\n  background-color: #007887;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  color: white;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n// @font-face {\r\n//   font-family: 'inoubd';\r\n//   src: url('a1xex-u3e2x.ttf');\r\n// }\r\n\r\n// .usefont{\r\n//   font-family: 'inoubd', sans-serif;\r\n// }\r\n\r\n.messageInfo{\r\n  border-left: 4px solid green;\r\n  box-shadow: 1px 1px 6px 0px grey;\r\n  border-radius: 5px;\r\n  padding-inline: 6px;\r\n  padding-block: 3px;\r\n}\r\n\r\n.cardActive{\r\nbackground-color: #CCE4E7;\r\n}\r\n\r\n.listview{\r\n  padding-inline: 19px;max-height: 53vh;overflow-x: hidden;overflow-y: auto;\r\n}\r\n\r\n\r\n.view_file_icon{\r\n    width: 19px !important;\r\n    float: left;\r\n    position: relative;\r\n    top: -3px;\r\n    left: 6px;\r\n}\r\n\r\n\r\n.barline{\r\n  height: 1px;\r\n  background-color: black;\r\n  margin-inline: 13px;\r\n}\r\n\r\n.lables_status{\r\n  border-radius: 4px;\r\n    padding-block: 3px;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n::ng-deep.viewstages .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n}\r\n\r\n.inputContainer{\r\n  height: 81vh;\r\n  background-color: #F3F3F3;\r\n  border: 1px solid #707070;\r\n  .header{\r\n    background-color: #D1D1D1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n.outputContainer{\r\n  height: 81vh;\r\n  background-color: #F3F3F3;\r\n  border: 1px solid #707070;\r\n  .header{\r\n    background-color: #D1D1D1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n\r\n.icons_list_style{\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n.icons_list_style_active{\r\n  border-bottom: 3px solid #00BCD4;\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n\r\n\r\n.case_info_container{\r\n  border: 1.5px solid #17a0b4;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n}\r\n\r\n.card_label_title{\r\n  background-color: #fbfbfb;\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 10px;\r\n  top: -9px;\r\n  color: #001C3B;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.lables_style{\r\n  font-size: 10px !important;\r\n  color: #001C3B;\r\n  font-weight: 600;\r\n  padding: 3px;\r\n}\r\n.value_style{\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  color: #5682A6 !important;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.supplemental_info{\r\n  height: 13vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n      font-size: 11px;\r\n}\r\n.inter_case_notes{\r\n    height: 19vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.archival_material{\r\n    height: 8vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.clinial_information{\r\n    height: 10vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.special_instructions{\r\n    height: 10vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.processing_notes{\r\n    height: 14vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.case_comments{\r\n    height: 14vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.supplemental_information{\r\n    height: 10vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n        font-size: 11px;\r\n}\r\n.case_rejections{\r\n    height: 10vh;\r\n     overflow-x: hidden;\r\n  overflow-y: auto;\r\n      font-size: 11px;\r\n}\r\n.Revison_reason{\r\n    height: 10vh;\r\n     overflow-x: hidden;\r\n  overflow-y: auto;\r\n      font-size: 11px;\r\n}\r\n.sec_date{\r\n\r\n    font-size: 10px;\r\n\r\n\r\n}\r\n.pt_date{\r\n\r\n    font-size: 9px;\r\n    margin-left: 3px;\r\n\r\n}\r\n\r\n.more_info{\r\n  color: blue;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.orderedDate{\r\n  color: #827EC4 !important;\r\n}\r\n.collectionDate{\r\n  color: #80A8D0 !important;\r\n}\r\n.receivedDate{\r\n  color: #278C7D !important;\r\n}\r\n.signedoutDate{\r\n  color: #D17800 !important;\r\n}\r\n.reportDate{\r\n  color: #C02755 !important;\r\n}\r\n.sendinDate{\r\n  color: #443EA7 !important;\r\n}\r\n.sendoutDate{\r\n  color: #3575B5 !important;\r\n}\r\n\r\n\r\n.insurance_more_info{\r\n  height: 62.5vh;\r\n}\r\n\r\n.text_elip{\r\n                  text-overflow: ellipsis;\r\n                  white-space: nowrap;\r\n                  overflow-x: hidden;\r\n}\r\n\r\n\r\n.flag_class{\r\n  background-color: #E8E8E5;\r\n  min-width: auto;\r\n  border-radius: 3px;\r\n  color: #001C3B;\r\n  font-size: 11px;\r\n  min-width: 164px !important;\r\n  padding-inline: 6px;\r\n  padding-block: 2px;\r\n  margin: 3px;\r\n  max-width: 320px;\r\n}\r\n\r\n\r\n.no_data{\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: #001C3B;\r\n}\r\n\r\n// Dynamic Test Results Sections\r\n.test_results,\r\n.observation_set_results,\r\n.standalone_results {\r\n  max-height: 50vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  font-size: 11px;\r\n}\r\n\r\n// Text truncation with ellipsis for long values\r\n.truncate-text {\r\n  max-width: 24ch;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n}\r\n\r\n// Special result content (Interpretation, Microscopic Notes, Diagnosis Summary)\r\n// Full-width display with text wrapping\r\n.special_result_content {\r\n  font-size: 10px;\r\n  color: #5682A6;\r\n  font-weight: 600;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  padding: 5px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.sub_groups_container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.sub_group_box {\r\n  border: 1px solid #17a0b4;\r\n  border-radius: 3px;\r\n  padding: 5px;\r\n  flex: 1 1 calc(50% - 8px);\r\n  min-width: 120px;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.sub_group_heading {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  color: #17a0b4;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  margin-bottom: 4px;\r\n  padding-bottom: 2px;\r\n}\r\n.material_control{\r\n  width: 100%;\r\n  height: 17px;\r\n  border: 1px solid #0d5964;\r\n  border-radius: 3px;\r\n}\r\n\r\n::ng-deep.myCustomModalViewfile .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n\r\n// Timezone Notice Styles - Fixed at bottom of screen\r\n.timezone-notice {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 8px 80px;\r\n  height: 40px;\r\n  z-index: 1000;\r\n  \r\n  .timezone-notice-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n    height: 100%;\r\n    padding-left: 15px;\r\n    \r\n    i {\r\n      margin-right: 8px;\r\n      color: #17a2b8;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    span {\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
